import { mapGetters, mapMutations } from 'vuex';
import EditOwner from "../../Owner/edit.vue";
import EditVehicle from "../../Common/editVehicle.vue";

import EditOrder from "@/views/Order/edit.js";

import Person from "./personComponent.vue";

import Vehicle from "./vehicleComponent.vue";

import InsuranceDetails from "./insuranceDetailsComponent.vue";

import EditProperty from "./../home-offer/editProperty.vue";

import EditInsuranceReqBuilding from "../home-offer/editInsuranceReqBuilding.vue";

import Offers from "../../Order/offersComponent.vue";

import FinishOrder from "./finishOrder.vue";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
    name: "rcaOffer",
    extends: EditOrder,
    components: {
        FormWizard,
        TabContent,
        Person,
        Vehicle,
        InsuranceDetails,
        Offers,
        FinishOrder,
        EditInsuranceReqBuilding,
    },

    props: {},

    data: () => {
        return {
            offersKey: 0,

        };
    },

    computed: {},
    created() {
        // set order as a site order

    },

    methods: {

        ...mapMutations({
            setCurrentOrderAsSiteOrder: 'order/setCurrentOrderAsSiteOrder',
        }),

        onTabChange: function (prevIndex, nextIndex) {

            // scroll to top
            window.scrollTo(0, 0);

            // update router param
            let query = JSON.parse(JSON.stringify(this.$route.query));
            if (nextIndex < 0) {
                query.step = 0;
            }
            else {
                query.step = nextIndex;
                this.$router.replace({ name: this.$router.name, query: query });
            }


            this.offersKey++;
        },

        saveOrderButtonClick: function () {
            this.setCurrentOrderAsSiteOrder(true);
            if (this.orderSettings.JsonSettings.PropertyType === 0) {

                const model = this;
                this.$store
                    .dispatch("order/saveOrder")
                    .then(() => {
                        model.$router.push({ name: "FinishOrder", params: { CurrentOrder: this.order }, query: null });
                    })
                    .catch(err => {
                        this.finished = false;
                        model.$bvToast.toast(
                            "A aparut o eroare. Te rugam incearca din nou.",
                            {
                                title: "Eroare",
                                variant: "danger",
                                autoHideDelay: 3000
                            }
                        );
                    });
            }
            else {
                alert('Selectati o oferta.');
            }
        },

        allOffersReceived: function () {
            //
            console.log("allOffersReceived");
        },

        validateVehicle: function () {
            //return true;
            return this.$refs.vehicle.validate();
        },
        validateDetails: function () {
            // pentru RCA punem oferta in cache pe server si apoi trecem la tabul urmator
            return new Promise((resolve, reject) => {
                var model = this;

                var isValid = this.$refs.details.validate();
                if (isValid) {
                    this.setCurrentOrderAsSiteOrder(true);
                    if (this.orderSettings.Id === 1 || this.orderSettings.Id === 3) { // RCA sau CASCO perfect cover
                        // RCA
                        this.$store
                            .dispatch("order/cacheOrder")
                            .then(function (cacheKey) {
                                model.setCurrentOrderCacheKey(cacheKey);
                                model.orderCachekey = cacheKey;
                                model.cachingOffer = false;
                                resolve(true);
                            });
                    } else {
                        resolve(true);
                    }
                } else {
                    resolve(false);
                }
            });
        },
        validatePerson: function () {
            //return true;
            var valid = this.$refs.person.validate();
            return valid;
        },
        validateProperty: function () {
            return this.$refs.property.validate();
        },
        validatePropertyReq: function () {
            return this.$refs.editInsuranceReqBuilding.validate();
        },
        onOrderSaved: function (order) {
            this.$router.push({ name: "FinishOrder", params: { CurrentOrder: order }, query:null });
        }
    }
};
